// extracted by mini-css-extract-plugin
export default {"edgebutton":"EdgeLine_edgebutton__Z5CED","crossButton":"EdgeLine_crossButton__sx3Md"};